import * as baseAPI  from "./API/baseAPI";
import { connectWebSocket } from "./API/websocket";
import * as alert from "./Util/alerts";
import * as helper from "./Util/helper";
import * as terms from "./Util/terms";
import * as multiSelector from "./UIController/multiSelector";
import { ReportManager } from "./components/ReportModal/report-modal";
import { SuggestionManager } from "./components/SuggestionModal/suggestion-modal";
import { ImageUploader } from "./components/ImageUploader/image-uploader";
import * as userCard from './components/UserCard/user-info';
import { loadImage } from "./UIController/imageloader";
import eventBus from "./events/eventBus";

export function getDeviceId() {
    return helper.getDeviceId();
}

export function getEventBus() {
    return eventBus;
}

export function showAlert(msg, type, timeout, callbackPromise, old) {
    alert.showAlert(msg, type, timeout, callbackPromise, old);
}

export function getQueryParams() {
    return helper.getQueryParams();
}

export function addQuery(key, value) {
    helper.addQuery(key, value);
}

export function removeQuery(key) {
    return helper.removeQuery(key);
}

export function hideModal(id) {
    helper.hideModal(id);
}

export function registerTriggerFunction(modal, callback) {
    helper.registerTriggerFunction(modal, callback);
}

export function closeModal(id) {
    hideModal(id);
}

export function showModal(id) {
    helper.showModal(id);
}

export function showSpinner() {
    baseAPI.showSpinner();
}

export function updateSelection(checkbox) {
    multiSelector.updateSelection(checkbox);
}

export function simpleDeleteRequestWithBody(url, data, spinnerId, callback) {
    baseAPI.simpleDeleteRequestWithBody(url, data, spinnerId, callback);
}

export function simpleDeleteRequest(url, spinnerId, callback) {
    baseAPI.simpleDeleteRequest(url, spinnerId, callback);
}

export function paginatedRequest(url, spinnerId, callback, force, silent) {
    baseAPI.paginatedRequest(url, spinnerId, callback, force, silent);
}

export function paginatedRequestWithBody(url, data, spinnerId, callback, force, silent) {
    baseAPI.paginatedRequestWithBody(url, data, spinnerId, callback, force, silent);
}

export function simplePutRequestWithBody(url, data, spinnerId, callback) {
    baseAPI.simplePutRequestWithBody(url, data, spinnerId, callback);
}

export function simplePostRequestWithBody(url, data, spinnerId, callback) {
    baseAPI.simplePostRequestWithBody(url, data, spinnerId, callback);
}

export function simplePostRequest(url, spinnerId, callback) {
    baseAPI.simplePostRequest(url, spinnerId, callback);
}

export function simpleGetRequest(url, spinnerId, callback) {
    baseAPI.simpleGetRequest(url, spinnerId, callback);
}

export function handleErrors(res, silent) {
    baseAPI.handleErrors(res, silent);
}

export function removeSelection(dropdownId, containerId, value) {
    multiSelector.removeDropdownSelection(dropdownId, containerId, value);
}

export function suggestions() {
    return SuggestionManager.getInstance();
}

export function reportUser(userId, userName) {
    ReportManager.getInstance().showReportModal({
        type: 'user',
        userId: userId,
        userName: userName,
    })
}

export function reportReview(reviewId, reviewTitle, userId, userName) {
    ReportManager.getInstance().showReportModal({
        type: 'content',
        contentId: reviewId,
        contentName: reviewTitle,
        userId: userId,
        userName: userName, 
    })
}

export function reportRating(userId, reviewId, username) {
    ReportManager.getInstance().showReportModal({
        type: 'content',
        contentId: userId + '-' + reviewId,
        contentName: t('report.ratingContentName', { reviewId: reviewId }),
        userId: userId,
        userName: username,
    })
}

export function report() {
    ReportManager.getInstance().showReportModal();
}

export function reports() {
    return ReportManager.getInstance();
}

export function showTermsChangesModal() {
    terms.showTermsChangesModal();
}

export function acceptChanges() {
    terms.acceptChanges();
}

export function deleteAccount() {
    terms.deleteAccountFromTerms();
}

export function logout() {
    terms.logout();
}

export function showConfirmationModal() {
    terms.showConfirmationModal();
}

export function shareCurrentLocation() {
    const params = helper.getQueryParams();
    if (window.location.href.includes('p=')) {
        helper.getShortLink(window.location.href, null, params.p, 'review', t('link.cta'), t('link.ctaDesc'));
    } else if (typeof data != 'undefined' && data.review != undefined && data.review.id != undefined) {
        helper.getShortLink(window.location.href, null, params.p, 'review', t('link.ctaPlace', { place: data.review.name }), t('link.ctaDesc'));
    } else {
        helper.shareLink(helper.getReviewHost() + window.location.pathname, t('link.cta'), t('link.ctaDesc'));
    }
}

export function imageLoader(url, element, wrapper, options) {
    loadImage(url, element, wrapper, options)
}

function initializeTheme() {
    const savedTheme = localStorage.getItem('theme') || alertUser?.settings?.theme?.type || 'light';

    // Only update switches, theme is already set
    requestAnimationFrame(() => {
        const switches = document.querySelectorAll('.theme-controller');
        switches.forEach(element => {
            element.checked = savedTheme === 'dark';
        });
    });
}

function initializeColorScheme() {
    const parsedScheme = localStorage.getItem('colorScheme');
    const colorScheme = parsedScheme? JSON.parse(parsedScheme) : undefined || alertUser?.settings?.theme || undefined

    if (colorScheme && colorScheme.primary && colorScheme.secondary && colorScheme.accent) {
        document.documentElement.style.setProperty('--color-primary', colorScheme.primary);
        document.documentElement.style.setProperty('--color-neutral', colorScheme.accent);
        document.documentElement.style.setProperty('--color-secondary', colorScheme.secondary);
        document.documentElement.style.setProperty('--color-accent', colorScheme.accent);
    }
}

initializeColorScheme();
const theme = localStorage.getItem('theme') || 'light';
document.documentElement.setAttribute('data-theme', theme);
window.addEventListener('load', initializeTheme, { once: true });

let themeSwitchBlocked = false;
export function toggleTheme() {
    if (themeSwitchBlocked) return;

    themeSwitchBlocked = true;
    
    const newTheme = helper.isDarkMode()? 'light' : 'dark';
    
    setTheme(newTheme);

    // Unblock after theme change is complete
    setTimeout(() => {
        themeSwitchBlocked = false;
    }, 100);

    if (App.account?.toggleDataChangeSubmitButton) {
        App.account.toggleDataChangeSubmitButton();
    }
}

export function getTheme() {
    return document.documentElement.getAttribute('data-theme');
}

export function setTheme(theme) {
    // Ensure theme is either 'dark' or 'light'
    const themes = ['light', 'dark'];
    theme = themes.includes(theme)? theme : 'light';
    
    // Set theme attribute
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);

    // Update all theme switches
    requestAnimationFrame(() => {
        const switches = document.querySelectorAll('.theme-controller');
        switches.forEach(element => {
            element.checked = theme === 'dark';
        });
    });

    eventBus.emit('theme:switch', { theme });
}

export function setColorScheme(scheme) {
    const { primary, secondary, accent } = scheme;
    document.documentElement.style.setProperty('--color-primary', primary);
    document.documentElement.style.setProperty('--color-secondary', secondary);
    document.documentElement.style.setProperty('--color-accent', accent);

    localStorage.setItem('colorScheme', JSON.stringify(scheme));
}

export function switchLang(lang) {
    if (!lang || (lang !== 'en' && lang !== 'de' && lang !== 'tr')) {
        console.error('Invalid language code');
        return;
    }

    window.location.href = window.location.pathname.replace(/\/(en|de|tr)\//, `/${lang}/`);
}

export function getCurrentUser() {
    return helper.getCurrentUser();
}

export function addFriend(username) {
    if (getCurrentUser() == null) {
        showAlert(t('errors.notLoggedIn'), 'error');
        return;
    }

    if (!username) {
        throw new Error(t('error.usernameRequired'));
    }

    baseAPI.simplePostRequest(`/api/v1/users/${username}/follow`, null);
}

export function removeFriend(username) {
    if (getCurrentUser() == null) {
        showAlert(t('errors.notLoggedIn'), 'error');
        return;
    }

    if (!username) {
        throw new Error(t('error.usernameRequired'));
    }

    baseAPI.simplePostRequest(`/api/v1/users/${username}/unfollow`, null);
}

export function blockUser(username) {
    if (getCurrentUser() == null) {
        showAlert(t('errors.notLoggedIn'), 'error');
        return;
    }

    if (!username) {
        throw new Error(t('error.usernameRequired'));
    }

    baseAPI.simplePostRequest(`/api/v1/users/${username}/block`, null);
}

export function unblockUser(username) {
    if (getCurrentUser() == null) {
        showAlert(t('errors.notLoggedIn'), 'error');
        return;
    }

    if (!username) {
        throw new Error(t('error.usernameRequired'));
    }

    baseAPI.simplePostRequest(`/api/v1/users/${username}/unblock`, null);
}

export function createUserCard(wrapper, user, config) {
    userCard.createUserCard(wrapper, user, config);
}

let uploader = null;
export function showUploadModal() {
    if (uploader) {
        uploader.clear();
        uploader = null;
    }

    uploader = new ImageUploader('fileInput', {
        size: 512,
        minWidth: 200,
        minHeight: 200,
        circular: true,
        allowedTypes: ['image/jpeg', 'image/png'],
        quality: 0.8,
        uploadButton: document.getElementById('uploadButton'),
        uploadUrl: '/api/v1/users/:username/upload',
        onCropped: (file) => {
        },
        onFileUploaded: (res) => {
            if (res.error) {
                baseAPI.handleErrors(res.error);
                return;
            }

            hideModal('uploadModal');
            showAlert(t('settings.pictureChanged'), 'success');
        }
    });

    document.getElementById('uploadFileInput').classList.remove('hidden');
    document.getElementById('uploadFileError').classList.add('hidden');
}

helper.registerTriggerFunction('uploadModal', showUploadModal);

document.addEventListener('DOMContentLoaded', () => {
    if (alertUser && !alertUser.email) {
        showAlert(t('errors.emailNotFound'), 'error');
    }

    // Check if user is logged in
    if (alertUser) {
        connectWebSocket();
    }

    const queryParams = helper.getQueryParams();
    if (queryParams.modal && queryParams.modal !== 'false' && queryParams.modal !== '') {
        setTimeout(() => {
            helper.showModal(queryParams.modal);
        }, 50);
    }
});

window.addEventListener('popstate', () => {
    const queryParams = helper.getQueryParams();
    if (queryParams.modal && queryParams.modal !== 'false' && queryParams.modal !== '') {
        setTimeout(() => {
            helper.showModal(queryParams.modal);
        }, 50);
    }
});

export function isLocal() {
    return helper.isLocal();
}

export function getDfBHost() {
    return helper.getDfBHost()
}

// Claim reward
export function claimReward() {
    const claimBtn = event.target;
    const id = claimBtn.id;
    
    baseAPI.simplePostRequest('/api/rewards/claim', id, handleClaim);
}

function handleClaim() {
    closeModal('winnerModal');
    showAlert(result.message || t('rewards.claimed'), 'success');
    
    if (typeof App.leaderboard.loadUserStats === 'function') {
        App.leaderboard.loadUserStats();
    }
}

// Invite friends function
export function inviteFriends() {
    const inviteText = t('invites.ctaDesc') + " 🍽️";
    const userId = getCurrentUser()?.id;
    const inviteUrl = userId ? `${window.location.origin}/invite?ref=${userId}` : window.location.origin;

    copyLink(inviteUrl, null, 'invite', t('invites.cta'), inviteText);
}

export function copyLink(link, spinnerId, type, title, description) {
    const userId = getCurrentUser()?.id;
    helper.getShortLink(link, spinnerId, userId, type, title, description);
}